import React from 'react';
import BentoCard from '../layout/BentoCard';
import { techStack } from '../../data/techStack';

/**
 * TechStackSection - Tech Stack display
 * Shows technologies organized by category
 */
const TechStackSection = () => {
  // Select main categories to display
  const displayCategories = {
    backend: techStack.backend.slice(0, 6),
    frontend: techStack.frontend.slice(0, 6),
    devops: techStack.devops.slice(0, 6),
    data: techStack.data.slice(0, 6)
  };

  return (
    <BentoCard span="2" delay={150}>
      <div className="p-6 h-full">
        <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">
          <span style={{ color: 'var(--color-accent)' }}>⚡</span>
          Tech Stack
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {Object.entries(displayCategories).map(([category, techs]) => (
            <div key={category}>
              <h3
                className="text-xs font-medium uppercase tracking-wider mb-3"
                style={{ color: 'var(--color-accent)' }}
              >
                {category}
              </h3>
              <div className="space-y-2">
                {techs.map((tech, index) => (
                  <div
                    key={index}
                    className="text-sm py-1 px-2 rounded-lg transition-all duration-300 hover:bg-white/5 hover:translate-x-1"
                    style={{ color: 'var(--color-text-muted)' }}
                  >
                    {tech}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </BentoCard>
  );
};

export default TechStackSection;
